var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSk = function SvgSk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.3,
    d: "M.85 5.85h30.3v20.3H.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE1C25",
    d: "M31 6H1v20h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4EA2",
    d: "M31 6H1v13.333h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31 6H1v6.667h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.053 10.7H6.227l-.03.269c-.006.058-.16 1.465-.16 4.556 0 1.452.525 2.733 1.562 3.808.727.752 1.676 1.386 2.902 1.937l.14.063.139-.063c1.226-.55 2.175-1.185 2.902-1.937 1.037-1.075 1.563-2.356 1.563-3.808 0-3.09-.155-4.498-.161-4.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE1C25",
    d: "M10.64 21c-1.762-.792-4.283-2.365-4.283-5.475S6.517 11 6.517 11h8.247s.16 1.415.16 4.525S12.402 20.208 10.64 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.018 14.71c.477.007 1.408.024 2.237-.235 0 0-.022.277-.022.6s.022.599.022.599c-.76-.238-1.7-.242-2.237-.236v1.718h-.754v-1.718c-.537-.007-1.476-.002-2.237.236 0 0 .022-.277.022-.6s-.022-.599-.022-.599c.83.26 1.76.242 2.237.234v-1.078a5.6 5.6 0 0 0-1.77.237s.022-.277.022-.6-.022-.6-.022-.6c.708.222 1.334.242 1.768.238-.022-.683-.235-1.544-.235-1.544s.439.031.614.031c.176 0 .614-.031.614-.031s-.213.86-.235 1.544a5.6 5.6 0 0 0 1.768-.237s-.022.277-.022.6.022.598.022.598a5.6 5.6 0 0 0-1.77-.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B4EA2",
    d: "M10.64 16.97c-.888 0-1.364 1.149-1.364 1.149s-.263-.545-.987-.545c-.49 0-.851.407-1.081.783.891 1.324 2.314 2.14 3.431 2.643 1.118-.503 2.542-1.32 3.433-2.643-.23-.376-.59-.783-1.08-.783-.725 0-.99.545-.99.545s-.475-1.15-1.363-1.15"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    d: "M3.25 12.4c0-1.124 0-1.952.054-2.607.053-.651.158-1.109.355-1.495a3.75 3.75 0 0 1 1.639-1.64c.386-.196.844-.301 1.495-.354.655-.054 1.483-.054 2.607-.054h13.2c1.124 0 1.952 0 2.607.054.651.053 1.109.158 1.495.355a3.75 3.75 0 0 1 1.64 1.639c.196.386.301.844.354 1.495.054.655.054 1.483.054 2.607v7.2c0 1.124 0 1.952-.054 2.607-.053.651-.158 1.109-.355 1.495a3.75 3.75 0 0 1-1.639 1.64c-.386.196-.844.301-1.495.354-.655.054-1.483.054-2.607.054H9.4c-1.124 0-1.952 0-2.607-.054-.651-.053-1.109-.158-1.495-.355a3.75 3.75 0 0 1-1.64-1.639c-.196-.386-.301-.844-.354-1.495-.054-.655-.054-1.483-.054-2.607z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })))));
};
export default SvgSk;